import { create } from 'zustand';

/**
 * The bits of "what the user is looking at" that aren't in the URL, published
 * for Baxter's implicit context (AB#645). Today that's only the theme route's
 * open file, which is component state. Routes set it in an effect and clear it
 * on unmount.
 */
interface EditorContextState {
  themeFile: string | null;
  setThemeFile: (file: string | null) => void;
  canvasSelection: { pageId: string; excerpt: string } | null;
  setCanvasSelection: (selection: { pageId: string; excerpt: string } | null) => void;
}

export const useEditorContext = create<EditorContextState>((set) => ({
  themeFile: null,
  setThemeFile: (themeFile) => set({ themeFile }),
  canvasSelection: null,
  setCanvasSelection: (canvasSelection) => set({ canvasSelection }),
}));
